import { render } from "./CreateCheck.vue?vue&type=template&id=0bcc5c74&scoped=true"
import script from "./CreateCheck.vue?vue&type=script&lang=js"
export * from "./CreateCheck.vue?vue&type=script&lang=js"

import "./CreateCheck.vue?vue&type=style&index=0&id=0bcc5c74&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcc5c74"]])

export default __exports__